<script setup lang="ts">
import { onMounted, ref } from 'vue'

const props = defineProps<{
  trackingPixel?: string
}>()

const trackingPixelUrl = ref<string | undefined>(undefined)

// mounted is only executed on client so no SSR caching will be involved here
onMounted(() => {
  if (props.trackingPixel && props.trackingPixel.length > 0) {
    // the replace is copied from Ströer, previously known as axel. RIP axel
    trackingPixelUrl.value = props.trackingPixel.replace('{{UNIQUE_VAR}}', String(Math.random() * 10000000000000))
  }
})
</script>

<template>
  <iframe v-if="trackingPixelUrl"
          :src="trackingPixelUrl"
          title="Tracking Pixel"
          style="display: none;" />
</template>
